import React from 'react'
import { Route, Routes, useMatch } from 'react-router-dom'
import HeaderContainer from './HeaderContainer'
import LoginContainer from './LoginContainer'
import ClientContainer from './ClientContainer'
import ClientsContainer from './ClientsContainer'
import AdminHeaderContainer from './AdminHeaderContainer'

const styles = {
  container: {
    margin: '48px 72px',
  },
}

interface Props {
  children?: React.ReactNode
}

const RootContainer: React.FC<Props> = ({ children }) => {
  const isLogin = useMatch('/admin/login')
  const isAdminRoot = useMatch('/admin')

  return (
    <div>
      {(!isLogin && !isAdminRoot) && <HeaderContainer />}
      {isAdminRoot && <AdminHeaderContainer />}

      <div style={isAdminRoot ? styles.container : {}}>
        {children}

        <Routes>
          <Route path="/login" element={<LoginContainer />} />
          <Route
            path="/clients/:urlName/*"
            element={<ClientContainer />}
          />
          <Route path="/" element={<ClientsContainer />} />
        </Routes>
      </div>
    </div>
  )
}

export default RootContainer
